import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchProductByType } from './utilities/fetch-product-by-type';
var ProductDirectiveController = /** @class */ (function (_super) {
    __extends(ProductDirectiveController, _super);
    function ProductDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        if (this.$transcludeScope !== undefined) {
            this.$transcludeScope.$destroy();
            this.$transcludeScope = undefined;
            this.$element.empty();
        }
        this.$transclude(this.$scope, function ($clonedElement, $transcludeScope) {
            _this.$transcludeScope = $transcludeScope;
            if (!$clonedElement) {
                return;
            }
            _this.$element.append($clonedElement);
        });
        var _a = this.$scope, pType = _a.pType, includeType = _a.includeType;
        this.$q.when(fetchProductByType(productId, pType, includeType))
            .then(function (product) {
            if (!product) {
                _this.removeProduct();
                return;
            }
            _this.$scope.product = product;
        }, function () {
            _this.removeProduct();
        });
    };
    ProductDirectiveController.prototype.removeProduct = function () {
        this.$element.remove();
        this.$scope.$destroy();
    };
    ProductDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductDirectiveController;
}(ProductDirectiveBaseController));
export var ProductDirective = [
    function () {
        return {
            controller: ProductDirectiveController,
            restrict: 'E',
            scope: {
                pId: '=',
                pType: '@',
                includeType: '@'
            },
            transclude: true,
        };
    },
];
